<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="textDate"
        prepend-inner-icon="mdi-calendar-blank"
        :readonly="!allowInput"
        v-bind="attrs"
        v-on="on"
        outlined
        dense
        :hide-details="hideDetails"
        :label="label"
        :rules="rules"
        :clearable="clearable"
        :error="hasError"
        :error-messages="errorMessage"
        @blur="onInputBlur"
        @keyup.enter="onInputBlur"
        @keydown="onlyAllowNumbersAndHyphen"
      ></v-text-field>
    </template>
    <v-date-picker no-title v-model="innerDate" :type="type" @input="onDatePicked" />
  </v-menu>
</template>

<script>
  export default {
    name: 'Calendar',
    props: {
      type: {
        type: String,
        default: 'date',
      },
      value: {
        type: String,
      },
      label: {
        type: String,
      },
      rules: {
        type: Array,
      },
      clearable: {
        type: Boolean,
      },
      hideDetails: {
        type: Boolean,
        default: false,
      },
      allowInput: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        textDate: this.value || '',
        innerDate: this.value || '',
        menu: false,
        hasError: false,
        errorMessage: '',
      };
    },
    watch: {
      value(val) {
        this.textDate = val;
        this.innerDate = val;
      },
    },
    methods: {
      formatDate(str) {
        const raw = str.replace(/\D/g, '');
        console.log(raw);
        const match = this.type === 'month' ? raw.match(/^(\d{4})(\d{2})$/) : raw.match(/^(\d{4})(\d{2})(\d{2})$/);
        if (!match) return null;

        const pad = (n) => n.padStart(2, '0');
        const [, year, month, day] = match;
        return this.type === 'month' ? `${year}-${pad(month)}` : `${year}-${pad(month)}-${pad(day)}`;
      },
      isValidDate(str) {
        const parts = str.split('-').map(Number);
        const date =
          this.type === 'month' ? new Date(parts[0], parts[1] - 1) : new Date(parts[0], parts[1] - 1, parts[2]);

        if (this.type === 'month') {
          return date.getFullYear() === parts[0] && date.getMonth() === parts[1] - 1;
        } else {
          return date.getFullYear() === parts[0] && date.getMonth() === parts[1] - 1 && date.getDate() === parts[2];
        }
      },
      onInputBlur() {
        const formatted = this.formatDate(this.textDate);
        if (!formatted || !this.isValidDate(formatted)) {
          this.setError(this.$t('invalidDateEntered'));
          return;
        }

        this.clearError();
        this.textDate = formatted;
        this.innerDate = formatted;
        this.$emit('input', formatted);
      },
      setError(message) {
        this.hasError = true;
        this.errorMessage = message;
      },
      clearError() {
        this.hasError = false;
        this.errorMessage = '';
      },
      onlyAllowNumbersAndHyphen(e) {
        const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End', 'Enter'];
        const isSingleChar = e.key.length === 1;
        const isValid = (isSingleChar && /^[0-9-]$/.test(e.key)) || allowedKeys.includes(e.key);
        if (!isValid) e.preventDefault();
      },
      onDatePicked(val) {
        this.clearError();
        this.innerDate = val;
        this.textDate = val;
        this.$emit('input', val);
        this.menu = false;
      },
    },
  };
</script>
